class Timer {
  constructor(element) {
    this.element = element;
    this.target_date_str = element.dataset.targetDate;
    this.target_time_str = element.dataset.targetTime;

    if (!this.target_date_str || !this.target_time_str) return;

    // Create target date in MST timezone
    this.target_date_time = this.create_mst_date(this.target_date_str, this.target_time_str);

    this.days_element = element.querySelector('[data-unit="days"]');
    this.hours_element = element.querySelector('[data-unit="hours"]');
    this.minutes_element = element.querySelector('[data-unit="minutes"]');
    this.seconds_element = element.querySelector('[data-unit="seconds"]');

    this.init();
  }

  create_mst_date(date_str, time_str) {
    // MST is UTC-7, create date string with timezone offset
    const date_time_str = `${date_str}T${time_str}:00-07:00`;
    return new Date(date_time_str);
  }

  init() {
    this.update_timer();
    this.interval = setInterval(() => this.update_timer(), 1000);
  }

  update_timer() {
    const now = new Date().getTime();
    const target_time = this.target_date_time.getTime();
    const time_difference = target_time - now;

    if (time_difference > 0) {
      const days = Math.floor(time_difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((time_difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((time_difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((time_difference % (1000 * 60)) / 1000);

      if (this.days_element) this.days_element.textContent = String(days).padStart(2, '0');
      if (this.hours_element) this.hours_element.textContent = String(hours).padStart(2, '0');
      if (this.minutes_element) this.minutes_element.textContent = String(minutes).padStart(2, '0');
      if (this.seconds_element) this.seconds_element.textContent = String(seconds).padStart(2, '0');
    } else {
      if (this.days_element) this.days_element.textContent = '00';
      if (this.hours_element) this.hours_element.textContent = '00';
      if (this.minutes_element) this.minutes_element.textContent = '00';
      if (this.seconds_element) this.seconds_element.textContent = '00';

      clearInterval(this.interval);
    }
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const timer_elements = document.querySelectorAll('.c-timer__display');

  timer_elements.forEach(element => {
    new Timer(element);
  });
});
